import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import translate from '@translate';
import { ApplicationInstallType } from '../../types/ApplicationInstall';
import {
    activateApplicationInstallFetchFailure,
    activateApplicationInstallFetchSuccess,
    deactivateApplicationInstallFetchFailure,
    deactivateApplicationInstallFetchSuccess,
    getApplicationInstallFetch,
    getApplicationInstallFetchFailure,
    getApplicationInstallFetchSuccess,
    installApplicationInstallFetchFailure,
    installApplicationInstallFetchSuccess
} from './reducer';

const getApplicationInstallDetailFetchRequest = async (idProvider: number) => {
    const res = await api('get', `api/secure/application-install/${idProvider}`);
    return res.data.data;
};

function* getApplicationInstallDetailFetch(action: { type: string; payload: number }) {
    try {
        const response: ApplicationInstallType = yield call((): any =>
            getApplicationInstallDetailFetchRequest(action.payload)
        );
        yield put(getApplicationInstallFetchSuccess(response));
    } catch (error) {
        yield put(getApplicationInstallFetchFailure({ error }));
    }
}

export function* getApplicationInstallDetailFetchWatch() {
    yield takeEvery(
        'applicationInstallDetail/getApplicationInstallFetch',
        getApplicationInstallDetailFetch
    );
}

const installApplicationInstallDetailFetchRequest = async (idProvider: number) => {
    const res = await api('put', `api/secure/application-install/${idProvider}`);
    return res.data.data;
};

function* installApplicationInstallDetailFetch(action: { type: string; payload: number }) {
    try {
        const response: ApplicationInstallType = yield call((): any =>
            installApplicationInstallDetailFetchRequest(action.payload)
        );
        yield put(getApplicationInstallFetch(action.payload));
        yield put(installApplicationInstallFetchSuccess({
            ...response,
            messageSuccess: { title: translate('systemConfigDetail.message.applicationInstalled') }
        }));
    } catch (error) {
        yield put(installApplicationInstallFetchFailure({ error }));
    }
}

export function* installApplicationInstallDetailFetchWatch() {
    yield takeEvery(
        'applicationInstallDetail/installApplicationInstallFetch',
        installApplicationInstallDetailFetch
    );
}

const activateApplicationInstallDetailFetchRequest = async (idProvider: number, active: boolean, inTest: boolean) => {
    const res = await api('put', `api/secure/application-install/${idProvider}/activate`, { active, inTest });
    return res.data.data;
};

function* activateApplicationInstallDetailFetch(action: { type: string; payload: { idProvider: number; active: boolean; inTest: boolean } }) {
    try {
        const response: ApplicationInstallType = yield call((): any =>
            activateApplicationInstallDetailFetchRequest(action.payload.idProvider, action.payload.active, action.payload.inTest)
        );
        yield put(getApplicationInstallFetch(action.payload.idProvider));
        yield put(activateApplicationInstallFetchSuccess({
            ...response,
            messageSuccess: { title: translate('systemConfigDetail.message.applicationActivated') }
        }));
    } catch (error) {
        yield put(activateApplicationInstallFetchFailure({ error }));
    }
}

export function* activateApplicationInstallDetailFetchWatch() {
    yield takeEvery(
        'applicationInstallDetail/activateApplicationInstallFetch',
        activateApplicationInstallDetailFetch
    );
}

const deactivateApplicationInstallDetailFetchRequest = async (idProvider: number, active: boolean, inTest: boolean) => {
    const res = await api('put', `api/secure/application-install/${idProvider}/deactivate`, { active, inTest });
    return res.data.data;
};

function* deactivateApplicationInstallDetailFetch(action: { type: string; payload: { idProvider: number; active: boolean; inTest: boolean } }) {
    try {
        const response: ApplicationInstallType = yield call((): any =>
            deactivateApplicationInstallDetailFetchRequest(action.payload.idProvider, action.payload.active, action.payload.inTest)
        );
        yield put(getApplicationInstallFetch(action.payload.idProvider));
        yield put(deactivateApplicationInstallFetchSuccess({
            ...response,
            messageSuccess: { title: translate('systemConfigDetail.message.applicationDeactivated') }
        }));
    } catch (error) {
        yield put(deactivateApplicationInstallFetchFailure({ error }));
    }
}

export function* deactivateApplicationInstallDetailFetchWatch() {
    yield takeEvery(
        'applicationInstallDetail/deactivateApplicationInstallFetch',
        deactivateApplicationInstallDetailFetch
    );
}
